import { render, staticRenderFns } from "./AdministratorsEdit.vue?vue&type=template&id=709f6336&"
import script from "./AdministratorsEdit.vue?vue&type=script&lang=js&"
export * from "./AdministratorsEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports